import * as React from "react";
import type { SVGProps } from "react";
const SvgLanguageTranslate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.01 7.05c2.57.21 4.99 1.29 4.99 3.81v.01c0 1.92-.91 3.33-2.61 4.06a.998.998 0 0 1-1.31-.53c-.22-.5.01-1.09.52-1.31.96-.41 1.39-1.1 1.39-2.22 0-.3-.1-.54-.26-.75-.67 2.09-2.49 3.89-4.24 3.89-2.06 0-3.5-1.58-3.5-3C2.99 8.82 4.08 7.44 6 7.1V6.01H4c-.55 0-1-.45-1-1s.45-1 1-1h2.01c0-.55.45-1 1-1s1 .45 1 1h3c.55 0 1 .45 1 1s-.45 1-1 1h-3zM6.05 9.12C5.31 9.36 5 9.94 5 11c0 .28.5.95 1.42.99-.21-.65-.32-1.53-.37-2.87m2-.06c.02.72.07 1.29.14 1.72.33-.45.6-.99.73-1.58-.3-.07-.6-.11-.87-.14m8.86 1.53 4 9v-.01a1.01 1.01 0 0 1-.92 1.41c-.38 0-.74-.22-.91-.59l-.62-1.41h-4.92l-.62 1.41a1 1 0 1 1-1.83-.81l4-9a.998.998 0 0 1 1.82 0m-.92 2.87L14.42 17h3.14z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLanguageTranslate;
